import "./style.css";

import {
  ComposedInputField,
  type ComposedInputFieldProps,
} from "../composedInputField/ComposedInputField";

type SsnInputProps = ComposedInputFieldProps & {
  id: string;
  label?: string;
  ref?: React.Ref<HTMLInputElement>;
};

export const SsnInput = ({
  popoverMessage,
  onChange,
  ref,
  ...rest
}: SsnInputProps) => {
  return (
    <ComposedInputField
      {...rest}
      ref={ref}
      popoverMessage={popoverMessage}
      type={"text"}
      className="ssn-input"
      onChange={(e) => {
        if (onChange) {
          const { value } = e.target;
          const capitalizedValue = value?.toUpperCase();
          const syntheticEvent = {
            ...e,
            target: {
              ...e.target,
              value: capitalizedValue,
            },
          };
          onChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
        }
      }}
    />
  );
};
